import { getOwnerInfo } from 'src/local-logic/tip-match/owner-info';

export default  {
  namespaced: true,
  state: () => ({
    uid: '',
    nick: '',
    head: '',
    gameInfo: {},
    ownerInfo: {},
  }),
  mutations: {
    setUid(state, uid) {
      state.uid = uid;
    },
    setNick(state, nick) {
      state.nick = nick;
    },
    setHead(state, head) {
      state.head = head;
    },
    setGameInfo(state, info) {
      state.gameInfo = {
        ...(state.gameInfo || {}),
        ...(info || {}),
      };
    },
    setOwnerInfo(state, rsp) {
      state.ownerInfo = {
        name: rsp?.principal_info?.nick || '',
        head: rsp?.principal_info?.head || '',
        id: rsp?.principal_info?.principal_id || '',
        status: rsp?.principal_info?.auth_status || 0,
        uid: rsp?.principal_info?.uid || 0,
        levelStage: rsp?.principal_info?.level_stage || 1,
        level: rsp?.principal_info?.level || 0,
        matchNum: rsp?.hold_num || 0,
        peopleNum: rsp?.game_mems || 0,
        societyId: rsp?.principal_info?.society_id || '',
        societyRole: rsp?.principal_info?.society_identity || 2,
        societyName: rsp?.principal_info?.society_name || '',
      };
    },
  },
  actions: {
    async getOwnerInfo(context) {
      await getOwnerInfo().then((res) => {
        context.commit('setOwnerInfo', res);
      })
        .catch((err) => {
          console.warn('vuex.getOwnerInfo.err', err);
        });
    },
  },
};
